module.exports = __webpack_public_path__ + "static/img/img29.8878753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img29.png
// module id = Ze+A
// module chunks = 1